export const eventBus = new EventTarget();
export type EventBusEvent = Event & { detail?: { status: number } };
